/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierGenerateMonthlyBillRequest
 */
export interface CourierGenerateMonthlyBillRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierGenerateMonthlyBillRequest
     */
    courierId?: string;
    /**
     * 
     * @type {number}
     * @memberof CourierGenerateMonthlyBillRequest
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof CourierGenerateMonthlyBillRequest
     */
    year?: number;
}

/**
 * Check if a given object implements the CourierGenerateMonthlyBillRequest interface.
 */
export function instanceOfCourierGenerateMonthlyBillRequest(value: object): value is CourierGenerateMonthlyBillRequest {
    return true;
}

export function CourierGenerateMonthlyBillRequestFromJSON(json: any): CourierGenerateMonthlyBillRequest {
    return CourierGenerateMonthlyBillRequestFromJSONTyped(json, false);
}

export function CourierGenerateMonthlyBillRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierGenerateMonthlyBillRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'month': json['month'] == null ? undefined : json['month'],
        'year': json['year'] == null ? undefined : json['year'],
    };
}

export function CourierGenerateMonthlyBillRequestToJSON(json: any): CourierGenerateMonthlyBillRequest {
    return CourierGenerateMonthlyBillRequestToJSONTyped(json, false);
}

export function CourierGenerateMonthlyBillRequestToJSONTyped(value?: CourierGenerateMonthlyBillRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
        'month': value['month'],
        'year': value['year'],
    };
}

